import { render, staticRenderFns } from "./AgentSidebar.vue?vue&type=template&id=4d20838f&scoped=true"
import script from "./AgentSidebar.vue?vue&type=script&lang=js"
export * from "./AgentSidebar.vue?vue&type=script&lang=js"
import style0 from "./AgentSidebar.vue?vue&type=style&index=0&id=4d20838f&prod&scoped=true&lang=css"
import style1 from "./AgentSidebar.vue?vue&type=style&index=1&id=4d20838f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d20838f",
  null
  
)

export default component.exports